import React from 'react';
import { Link } from 'react-router-dom'; 
import { HiOutlineSparkles } from "react-icons/hi2";
import { trackCTAClick } from '../../Actions/analytics';

// Make sure this path exactly matches where your Routes are stored
import { ROUTES } from '../../constants/routes'; 

const AnnouncementCard = () => {
  return (
    <div className="relative overflow-hidden bg-slate-950 border-b border-white/10 shadow-lg">
      {/* Subtle Animated Glow Effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 via-transparent to-indigo-500/10 animate-pulse" />

      <div className="relative max-w-7xl mx-auto px-4 py-3">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6">
          
          {/* Tag / Badge */}
          <div className="flex items-center gap-2">
            <span className="flex h-2.5 w-2.5 relative">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-blue-500"></span>
            </span>
            <span className="bg-blue-500/10 text-blue-400 text-[11px] font-bold uppercase tracking-widest px-2.5 py-0.5 rounded-full border border-blue-500/20">
              Hiring Interns
            </span>
          </div>

          {/* Main Message */}
          <p className="text-slate-200 text-sm font-medium tracking-tight text-center">
            Want to help build the future of <span className="text-blue-400 font-bold">CampusIRA</span>? 
            <span className="hidden sm:inline text-slate-400 ml-1">— We're looking for passionate developers to join the core team.</span>
          </p>

          {/* CTA Link - Using React Router's 'to' prop */}
          <Link 
            to={ROUTES.hiring}
            onClick={() => trackCTAClick('announcement_apply', ROUTES.hiring)}
            className="flex items-center gap-1.5 bg-white text-slate-900 px-5 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider hover:bg-blue-500 hover:text-white transition-all duration-200 active:scale-95 shadow-md hover:shadow-blue-500/20"
          >
            Apply Now
            <HiOutlineSparkles size={16} className="animate-bounce" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementCard;